<template>
  <div>
    <div class="title">支付方式？</div>
    <div class="content-info">
      <p class="txt1">在线支付</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
